import styled from 'styled-components';
import { DESKTOP_WIDTH, TABLET_WIDTH, MOBILE_WIDTH, ANIMATION_SPEED } from '../globalUtils';
import InsLDBG from '../../images/ins-ld-bg.png';
import InsLDBGL from '../../images/ins-ld-bg-low.png';
import InsLDBGTablet from '../../images/ins-ld-bg-tablet.png';
import InsLDBGTabletL from '../../images/ins-ld-bg-tablet-low.png';
import InsLDBGMobile from '../../images/ins-ld-bg-mobile.png';
import InsLDBGMobileL from '../../images/ins-ld-bg-mobile-low.png';
import { ReactComponent as ShieldWhiteSVG } from '../../icons/ShieldWhite.svg'
import { ReactComponent as HeartFillSVG } from '../../icons/HeartFill.svg';

export { Area } from './index.style';

export const Container = styled.div`
    display: flex;
    justify-content: center;
    flex: 1 1 auto;
    width: 100%;
    background-image: url(${InsLDBG}), url(${InsLDBGL});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        background-image: url(${InsLDBGTablet}), url(${InsLDBGTabletL});
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        background-image: url(${InsLDBGMobile}), url(${InsLDBGMobileL});
    }
`;

export const Holder = styled.div`
    display: flex;
    flex-direction: row;
    height: 622px;
    border-radius: 60px 20px 0 0;
    overflow: hidden;
    margin: 60px 0 40px;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        flex-direction: column;
        align-self: center;
        height: auto;
        width: 564px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: 320px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: 284px;
    }
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 520px;
    background-color: rgba(0, 58, 112, 0.9);
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        width: auto;
    }
`;

export const ShieldWhite = styled(ShieldWhiteSVG)`
    margin-top: 189px;
    height: 105px;
    width: 89px;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        margin-top: 54px;
        height: 73px;
        width: 62px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        margin-top: 35px;
        height: 51px;
        width: 43px;
    }
`;

export const InfoTitle = styled.div`
    color: #f7f8f8;
    font-size: 40px;
    font-weight: 600;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        margin-bottom: 37px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        margin-bottom: 20px;
        font-size: 24px;
    }
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    padding: 72px 37px 0;
    width: 444px;
    background-color: rgba(255, 255, 255, 0.9);
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        width: auto;
        padding: 39px 67px 0;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        padding: 39px 31px 0;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        padding: 39px 13px 0;
    }
`;

export const FormTitle = styled.div`
    color: #003a70;
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 14px;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 18px;
    }
`;

export const FormSubText = styled.div`
    color: #003a70;
    text-align: center;
    font-size: 16px;
    margin-bottom: 39px;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 14px;
    }
`;

export const Names = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const TextInput = styled.input.attrs(() => ({
    type: 'text',
}))`
    height: 18px;
    background-color: #f9fbff;
    border: 2px solid rgb(79, 103, 146);
    border-radius: 2px;
    transition: ${ANIMATION_SPEED}ms all ease-in-out;
    margin-bottom: 19px;
    outline: 0;
    color: #003a70;
    font-size: 18px;
    padding: 13px 11px;

    ::placeholder {
        color: #003a70;
    }
    :focus {
        ::placeholder {
            color: #ff4438;
        }
        color: #ff4438;
        border: 2px solid rgb(255, 68, 56);
    }

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        padding: 9px 11px;
        font-size: 13px;
        margin-bottom: 10px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        padding: 8px 9px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        font-size: 12px;
    }
`;

export const NarrowTextInput = styled(TextInput)`
    width: 184px;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        width: 184px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: 102px;
    }
`;

export const WideTextInput = styled(TextInput)`
    width: calc(100% - 26px);
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: calc(100% - 22px);
    }
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 25px;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        margin-bottom: 23px;
    }
`;

export const CheckBox = styled.div`
    position: relative;
    cursor: pointer;
    height: 12px;
    width: 12px;
    border: 1px solid rgb(0, 58, 112);
    margin-left: 9px;
    
    :after {
        content: '';
        width: 10px;
        height: 10px;
        transition: ${ANIMATION_SPEED}ms all ease-in-out;
        background-color: ${({ active }) => active ? 'rgb(0, 58, 112)' : 'transparent'};
        position: absolute;
        border-radius: 2px;
        top: 1px;
        right: 1px;
    }
`;

export const CheckBoxLabel = styled.a`
    color: #003a70;  
    font-size: 16px;
`;

export const Error = styled.div`
    text-align: center;
    color: #ff4438;
    font-size: 18px;
    margin-bottom: 17px;
    height: 23px;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 14px;
        margin-bottom: 13px;
    }
`;

export const CTAButton = styled.button.attrs(() => ({
    type: 'submit'
}))`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 53px;
    width: 437px;
    border: 0;
    background-color: #ff4438;
    border-radius: 7px;
    box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.5);
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 9px;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 33px;
        width: 258px;
        border-radius: 3.84px;
        box-shadow: 0 2px 3px 0px rgba(0, 0, 0, 0.5);
        font-size: 14px;
    }
`;

export const Cancel = styled.div`
    cursor: pointer;
    color: #003a70;
    text-align: center;
    font-size: 18px;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        margin-bottom: 41px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 15px;
        margin-bottom: 7px;
    }
`;

export const Thanks = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
    height: 392px;
    width: 592px;
    background-color: rgba(0, 58, 112, 0.9);
    border-radius: 2px;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 368px;
        width: 320px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        height: 368px;
        width: 284px;
    }
`;

export const HeartIcon = styled(HeartFillSVG)`
    height: 38px;
    width: 40px;
    margin: 41px 0 3px;
`;

export const ThanksTitle = styled.div`
    color: #faf9fa;
    text-align: center;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 44px;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 24px;
    }
`;

export const ThanksText = styled.div`
    color: #ffffff;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    width: 378px;
    margin-bottom: 54px;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: auto;
    }
`;

export const TanksButton = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 38px;
    width: 159px;
    background-color: #ff4438;
    border-radius: 7px;
    box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.5);
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
`; 
